

export default {
  chart: {
    labels: ["Jan","Feb","Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    datasets: { label: "Sales", data: [1250, 900, 750, 820, 900, 1010, 1400, 1230, 800] },
  },
  items: [
    {
      icon: { color: "primary", component: "person" },
      label: "users",
      progress: { content: "210K", percentage: 60 },
    },
    {
      icon: { color: "info", component: "touch_app" },
      label: "clicks",
      progress: { content: "3.2M", percentage: 90 },
    },
    {
      icon: { color: "warning", component: "payment" },
      label: "AOV",
      progress: { content: "$85", percentage: 60 },
    },
    {
      icon: { color: "info", component: "extension" },
      label: "items",
      progress: { content: "54", percentage: 100 },
    },
  ],
};
